import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import CurrenciesActions, { currenciesActionTypes } from '../../actions/configurations/currenciesAction';
import CurrenciesServices from '../../services/configurations/currenciesServices';

/**
 * @param action
 */

function* _createCurrencies(action) {
  try {
    yield put(CurrenciesActions.createCurrenciesLoading(true));
    const { payload } = action;
    const currencies = yield CurrenciesServices.createCurrencies(payload);
    if (!currencies.success) {
      notification.open({
        type: 'error',
        message: currencies?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: currencies?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(CurrenciesActions.createCurrenciesLoading(false));
  } catch (error) {
    yield put(CurrenciesActions.createCurrenciesLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */

function* createCurrencies() {
  yield takeLatest(currenciesActionTypes.CREATE_CURRENCIES.REQUEST, _createCurrencies);
}

function* _updateCurrencies(action) {
  try {
    yield put(CurrenciesActions.updateCurrenciesLoading(true));
    const { payload } = action;
    const currencies = yield CurrenciesServices.updateCurrencies(payload);
    if (!currencies.success) {
      notification.open({
        type: 'error',
        message: currencies?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: currencies?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(CurrenciesActions.updateCurrenciesLoading(false));
  } catch (error) {
    yield put(CurrenciesActions.updateCurrenciesLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */

function* updateCurrencies() {
  yield takeLatest(currenciesActionTypes.UPDATE_CURRENCIES.REQUEST, _updateCurrencies);
}

/**
 *
 * @param action
 */

function* _getCurrencies(action) {
  try {
    yield put(CurrenciesActions.getCurrenciesLoading(true));
    const { orgId } = action;
    const currencies = yield CurrenciesServices.getCurrencies(orgId);
    if (!currencies.success) {
      notification.open({
        type: 'error',
        message: currencies?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(CurrenciesActions.getCurrenciesSuccess(currencies?.data));
      if (action.callback) {
        action.callback();
      }
    }
    yield put(CurrenciesActions.getCurrenciesLoading(false));
  } catch (error) {
    yield put(CurrenciesActions.getCurrenciesLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */

function* getCurrencies() {
  yield takeLatest(currenciesActionTypes.GET_CURRENCIES.REQUEST, _getCurrencies);
}

/**
 * @param action
 */

function* _deleteCurrencies(action) {
  try {
    yield put(CurrenciesActions.deleteCurrenciesLoading(true));
    const { payload } = action;
    const currencies = yield CurrenciesServices.deleteCurrencies(payload);
    if (!currencies.success) {
      notification.open({
        type: 'error',
        message: currencies?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: currencies?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(currencies.seller);
      }
    }
    yield put(CurrenciesActions.deleteCurrenciesLoading(false));
  } catch (error) {
    yield put(CurrenciesActions.deleteCurrenciesLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* deleteCurrencies() {
  yield takeLatest(currenciesActionTypes.DELETE_CURRENCIES.REQUEST, _deleteCurrencies);
}

function* _getCurrencyConversionRate(action) {
  try {
    yield put(CurrenciesActions.getCurrencyConversionRateLoading(true));
    const { payload } = action;
    const currencies = yield CurrenciesServices.getCurrencyConversionRate(payload);

    if (!currencies.success) {
      notification.open({
        type: 'error',
        message: currencies?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(CurrenciesActions.getCurrencyConversionRateSuccess(currencies?.data));
      if (action.callback) {
        action.callback();
      }
    }
    yield put(CurrenciesActions.getCurrencyConversionRateLoading(false));
  } catch (error) {
    yield put(CurrenciesActions.getCurrencyConversionRateLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getCurrencyConversionRate() {
  yield takeLatest(currenciesActionTypes.GET_CURRENCY_CONVERSION_RATE.REQUEST, _getCurrencyConversionRate);
}

function* _refreshCurrencyConversionRate(action) {
  try {
    yield put(CurrenciesActions.refreshCurrencyConversionRateLoading(true));
    const { payload } = action;
    const currencies = yield CurrenciesServices.refreshCurrencyConversionRate(payload);
    if (!currencies.success) {
      notification.open({
        type: 'error',
        message: currencies?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Latest currency conversion rate updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(CurrenciesActions.refreshCurrencyConversionRateLoading(false));
  } catch (error) {
    yield put(CurrenciesActions.refreshCurrencyConversionRateLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* refreshCurrencyConversionRate() {
  yield takeLatest(currenciesActionTypes.REFRESH_CURRENCY_CONVERSION_RATE.REQUEST, _refreshCurrencyConversionRate);
}

/**
 *
 */
export default function* CurrenciesSaga() {
  yield all([
    createCurrencies(), updateCurrencies(), getCurrencies(), deleteCurrencies(), getCurrencyConversionRate(), refreshCurrencyConversionRate(),
  ]);
}
